var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinesMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 102.77 744.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke-width:5px;}.cls-1,.cls-2{stroke:#fff;stroke-miterlimit:10;}.cls-2{fill:#fff;stroke-width:3.1px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 42") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_5",
    "data-name": "Layer 5"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 8.22,
    y1: 10.23,
    x2: 8.22,
    y2: 734.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 88.72,
    y1: 736.38,
    x2: 5.72,
    y2: 736.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 88.72,
    y1: 323.38,
    x2: 5.72,
    y2: 323.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 8.22,
    cy: 8.22,
    r: 6.67
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 94.55,
    cy: 323.22,
    r: 6.67
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 94.55,
    cy: 736.22,
    r: 6.67
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinesMobile);
export default __webpack_public_path__ + "static/media/linesMobile.deaaa87db18142cc9369c13d411b3568.svg";
export { ForwardRef as ReactComponent };